import Image from 'next/image';
import React from 'react';

import Heading from '@components/Heading';
import Section from '@components/Section';
import { loaderProp } from '@utils/random';

const SeeWhatsPossibleSection = () => {
  const data = {
    heading: "See what's possible",
    chartTypes: [
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/area_chart.svg`,
        type: 'Area',
      },
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/pie_chart.svg`,
        type: 'Pie',
      },
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/combo_chart.svg`,
        type: 'Combo',
      },
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/big_number_chart.svg`,
        type: 'Big number',
      },
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/scatter_chart.svg`,
        type: 'Scatter',
      },
      {
        image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/line_chart.svg`,
        type: 'Line',
      },
    ],
  };
  return (
    <Section>
      <Heading
        Tag="h2"
        size="lg"
        className={`sm:max-w-xl mt-10 md:mt-20 lg:mt-24 text-center`}
      >
        {data.heading}
      </Heading>

      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 md:mt-20">
        {data.chartTypes.map((chart, index) => (
          <li
            key={index}
            className="border border-[#CFD5DB] rounded-[24px] text-center flex flex-col"
          >
            <Image
              alt={`${chart.type} chart illustration`}
              src={chart.image}
              height="325"
              width="378"
              loader={loaderProp}
            />

            <p className="my-6 mx-auto rounded-[200px] min-w-[88px] inline-block px-4 py-2 font-semibold font-inter text-black">
              {chart.type}
            </p>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default SeeWhatsPossibleSection;
